import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientProvider } from '../providers/client.provider';
import { FullClientInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UpdateClientUseCaseParams {
    client: FullClientInterface;
}

@Injectable()
export class UpdateClientUseCase implements UseCaseWithParam<UpdateClientUseCaseParams, Observable<Transaction<void>>> {
    constructor(private clientProvider: ClientProvider) {}

    bind(params: UpdateClientUseCaseParams): Observable<Transaction<void>> {
        return this.clientProvider.update(params.client);
    }
}
